<template>
  <div class="row gestor-analytics" ref="testHtml">
    <div class="col-md-12">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h2 class="mb-0 text-gray-800">Atendimentos</h2>

        <span class="inline-flex">
          <span class="mr-2">Período:</span>
          <span class="mr-2">
            <i class="fas fa-calendar"></i> {{ report.datas.start }}
          </span>
          <span> <i class="fas fa-calendar"></i> {{ report.datas.end }} </span>
        </span>
        <div class="d-flex align-items-center inline-flex">
          <b-form-select
            v-model="valueYear"
            :options="report.years"
            size="sm"
            class="mr-3"
            value-field="id"
            text-field="value"
            @change="changeAnotherFilter()"
          ></b-form-select>

          <b-form-select
            v-model="valueMonth"
            :options="report.months_history"
            size="sm"
            class="mr-3"
            value-field="id"
            text-field="value"
            @change="changeAnotherFilter()"
            style="min-width: 200px"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Selecione um mês --
              </b-form-select-option>
            </template>
          </b-form-select>
          <b-button-group>
            <b-button
              @click.prevent="limparFiltros()"
              class="mb-0"
              variant="outline-dark"
              title="Limpar campos"
              v-b-tooltip.hover
              size="xs"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
            <!-- <b-button
              @click.prevent="limparFiltros()"
              class="mb-0"
              variant="outline-dark"
              title="Gerar Excel com os dados"
              v-b-tooltip.hover
              size="xs"
            >
              <i class="fas fa-file-excel"></i>
            </b-button> -->
            <b-button
              @click.prevent="generatePdf()"
              class="mb-0"
              variant="outline-dark"
              title="Gerar PDF do Painel"
              v-b-tooltip.hover
              size="xs"
            >
              <i class="far fa-file-pdf"></i>
            </b-button>
            <b-button
              class="mb-0"
              variant="outline-dark"
              @click.prevent="exportCsv()"
              :title="$t('Exportar CSV')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
            <b-button
              class="mb-0"
              variant="outline-dark"
              size="xs"
              id="popover-button-datas"
              @click="showInputDatas = !showInputDatas"
              v-b-tooltip.hover
              title="Filtrar por intervalo de datas"
            >
              <i class="fas fa-filter"></i>
            </b-button>
          </b-button-group>
          <b-popover :show.sync="showInputDatas" target="popover-button-datas">
            <template #title>Filtrar por datas</template>

            <form @submit.prevent="getAnalytics" ref="addItem">
              <div class="row">
                <form-calendar
                  v-model="data_inicio"
                  grid="12"
                  label="Data Inicial"
                  :max-date="dataNow"
                />

                <form-calendar
                  v-model="data_fim"
                  grid="12"
                  label="Data Final"
                  :required="verificaDataInicial"
                  :min-date="data_inicio"
                  :max-date="dataNow"
                />
              </div>
              <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <button
                    class="btn btn-default btn-sm"
                    @click.prevent="limparFiltros(), (showInputDatas = false)"
                    v-b-tooltip.hover
                    title="Fechar janela e limpar campos"
                  >
                    <i class="fas fa-times"></i>
                  </button>

                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click.prevent="limparFiltros()"
                    v-b-tooltip.hover
                    title="Limpar campos"
                  >
                    <i class="fas fa-eraser"></i>
                  </button>

                  <button
                    class="btn btn-success btn-submit btn-sm"
                    data-style="zoom-in"
                    type="submit"
                    v-b-tooltip.hover
                    title="Iniciar filtro"
                  >
                    <i class="fas fa-share"></i>
                    {{ $t("Filtrar") }}
                  </button>
                </div>
              </div>
            </form>
          </b-popover>
        </div>
      </div>
    </div>

    <loading-report
      :loading="isLoadingMsg"
      mensagem="Por favor aguarde estamos realizando sua solicitação..."
      icone="fa-smile-wink"
    ></loading-report>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />

    <div class="col-md-12">
      <div class="row">
        <div class="col-md-4">
          <!-- Cards Atendimentos -->
          <CardCount
            :counts="counts.Atendimento"
            titulo="Atendimentos"
            link="/dashboard/relatorios/atendimentos/home"
            icone="fas fa-hands-helping"
            background="bg-primary"
            btnVariante="primary"
          />

          <CardCount
            :counts="counts.FamiliasAtendidas"
            titulo="Famílias Atendidas"
            link="/dashboard/relatorios/atendimentos/home"
            icone="mdi mdi-account-group"
            background="bg-success"
            btnVariante="success"
          />
        </div>

        <div class="col-md-8">
          <b-card class="shadow" no-body>
            <b-card-body class="p-2">
              <AreaGraph
                :months="report.months"
                :years="report.years"
                :items="report.lista_atendimentos"
                title="Histórico de Atendimentos"
                :year.sync="filtroYear"
                :month.sync="filtroMonth"
                @reload="getAnalytics"
              />
            </b-card-body>
          </b-card>
        </div>

        <div class="col-md-8">
          <b-card class="shadow" no-body>
            <div class="d-flex align-items-center justify-content-between">
              <p class="m-0 px-4 py-3 normal-line-height">Atendimentos por Unidades</p>
              <div class="float-right">
                <b-button
                  type="button"
                  class="btn btn-primary btn-xs btn-card"
                  to="/dashboard/relatorios/atendimentos/graficos"
                >
                  <i class="fas fa-external-link-alt"></i>
                </b-button>
              </div>
            </div>
            <b-card-body class="p-2">
              <NotResult v-if="report.unidades_atendimentos.length == 0" />
              <bar-chart
                v-else
                :colors="['rgb(60, 179, 255)']"
                :data="report.unidades_atendimentos"
                style="height: 300px"
              ></bar-chart>
            </b-card-body>
          </b-card>
        </div>

        <div class="col-md-4">
          <CardCount
            :counts="report.atendimentos_status['EM ANDAMENTO']"
            titulo="Atendimentos em andamento"
            link="/dashboard/relatorios/atendimentos/home"
            icone="fas fa-folder-open"
            background="bg-info"
            btnVariante="info"
          />

          <CardCount
            :counts="report.atendimentos_status['ABERTO']"
            titulo="Atendimentos em aberto"
            link="/dashboard/relatorios/atendimentos/graficos"
            icone="fas fa-exclamation-triangle"
            background="bg-danger"
            btnVariante="danger"
          />

          <CardCount
            :counts="report.atendimentos_status['DEMANDA REPRIMIDA']"
            titulo="Atendimentos Demanda Reprimida"
            link="/dashboard/relatorios/atendimentos/graficos"
            icone="fas fa-hand-paper"
            background="bg-warning"
            btnVariante="warning"
          />
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <b-card class="shadow" no-body>
        <div class="d-flex align-items-center justify-content-between">
          <p class="m-0 px-4 py-3 normal-line-height">
            Tipos de atendimentos mais realizados
          </p>
          <div class="float-right">
            <b-button
              type="button"
              class="btn btn-success btn-xs btn-card"
              to="/dashboard/relatorios/atendimentos/graficos"
            >
              <i class="fas fa-external-link-alt"></i>
            </b-button>
          </div>
        </div>
        <b-card-body class="p-2 card-table">
          <NotResult v-if="report.tipos_atendimentos.length == 0" />
          <pie-chart
            :donut="true"
            v-else
            :data="report.tipos_atendimentos"
            style="height: 380px"
          ></pie-chart>
        </b-card-body>
      </b-card>
    </div>

    <!--
    <div class="col-md-6">
      <b-card class="shadow" no-body>
        <div class="d-flex align-items-center justify-content-between">
          <p class="m-0 px-4 py-3 normal-line-height">
            Vulnerabilidades mais registradas em atendimentos
          </p>
          <div class="float-right">
            <b-button
              type="button"
              class="btn btn-success btn-xs btn-card"
              to="/dashboard/relatorios/atendimentos/graficos"
            >
              <i class="fas fa-external-link-alt"></i>
            </b-button>
          </div>
        </div>
        <b-card-body class="p-4 card-table">
          <NotResult v-if="report.por_vulnerabilidades.length == 0" />
          <b-table
            v-else
            striped
            hover
            small
            :items="report.por_vulnerabilidades"
            :fields="[
              {
                key: 'vulnerablidade',
                sortable: true,
              },
              {
                key: 'familias',
                sortable: true,
              },
            ]"
            :per-page="perPage"
            :current-page="currentPage"
            style="font-size: 12px"
            id="my-table"></b-table>
             <b-pagination
            v-if="report.por_vulnerabilidades.length > 0"
            v-model="pagination.currentPage"
            :total-rows="pagination.totalPages"
            :per-page="pagination.perPage"
            aria-controls="my-table"
            pills
            @change="changePage"
          ></b-pagination>
        </b-card-body>
      </b-card>
    </div>
    -->

    <div class="col-md-6">
      <b-card class="shadow" no-body>
        <div class="d-flex align-items-center justify-content-between">
          <p class="m-0 px-4 py-3 normal-line-height">Atendimentos por Status</p>
          <div class="float-right">
            <b-button
              type="button"
              class="btn btn-success btn-xs btn-card"
              to="/dashboard/relatorios/atendimentos/graficos"
            >
              <i class="fas fa-external-link-alt"></i>
            </b-button>
          </div>
        </div>
        <b-card-body class="p-2 card-table">
          <NotResult v-if="report.atendimentos_status.length == 0" />
          <pie-chart
            :donut="true"
            v-else
            :data="report.atendimentos_status"
            style="height: 380px"
          ></pie-chart>
        </b-card-body>
      </b-card>
    </div>

    <div class="col-md-12">
      <b-card class="shadow" no-body>
        <div class="d-flex align-items-center justify-content-between">
          <p class="m-0 px-4 py-3 normal-line-height">Atendimentos por Técnicos</p>
          <div class="float-right">
            <b-button
              type="button"
              class="btn btn-primary btn-xs btn-card"
              to="/dashboard/relatorios/atendimentos/graficos"
            >
              <i class="fas fa-external-link-alt"></i>
            </b-button>
          </div>
        </div>
        <b-card-body class="p-2">
          <NotResult v-if="report.tecnicos_atendimentos.length == 0" />
          <bar-chart
            :colors="['rgb(99, 199, 99)']"
            v-else
            :data="report.tecnicos_atendimentos"
            style="height: 170px"
          ></bar-chart>
        </b-card-body>
      </b-card>

      <div class="print" ref="print" v-show="showPrint">
        <img :src="output" width="560px" style="max-width: 560px" />
      </div>
    </div>
  </div>
</template>
<script>
import AreaGraph from "../includes/graphics/AreaGraph";
import NotResult from "../includes/graphics/NotResult";
import CardCount from "../includes/cards/CardCount";
import html2canvas from "html2canvas";

import { jsPDF } from "jspdf";

export default {
  name: "GestorAnalyticsAtendimentos",
  components: {
    AreaGraph,
    NotResult,
    CardCount,
  },
  metaInfo() {
    return {
      title: this.$i18n.t("Painel Analítico do Gestor"),
    };
  },
  computed: {
    rows() {
      return this.report.por_vulnerabilidades.length;
    },
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        totalPages:0
      },
      loading: false,
      isLoadingMsg: false,
      range: "yearly",
      counts: {},
      report: {
        lista_atendimentos: [],
        unidades_atendimentos: [],
        tecnicos_atendimentos: [],
        tipos_atendimentos: [],
        atendimentos_status: [],
        por_vulnerabilidades: [],
        datas: {
          start: "",
          end: "",
        },
        years: [],
        months: [],
        months_history: [],
      },
      valueYear: moment().format("YYYY"),
      valueMonth: null,
      filtroYear: moment().format("YYYY"),
      filtroMonth: null,
      sizeAtUnidades: "min-height: 200px",
      currentPage: 1,
      perPage: 1000,
      showInputDatas: false,
      filtroDatas: [],
      anotherFilter: [],
      output: null,
      showPrint: false,
    };
  },

  mounted() {
    this.getAnalytics();
    this.getAnalyticsVulnerabilidades();
  },
  methods: {
    changePage(value) {
      this.getAnalyticsVulnerabilidades(this.pagination.perPage,value) 
    },
    changeAnotherFilter() {
      this.anotherFilter = [];
      if (this.valueYear) {
        this.anotherFilter.push(this.valueYear);
      }
      if (this.valueMonth) {
        this.anotherFilter.push(this.valueMonth);
      }

      if (this.anotherFilter.length > 0) {
        this.getAnalytics();
      }
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalyticsVulnerabilidades(perPage=10,pageCurrent = 1) {
      //this.loading = true;
      this.showInputDatas = false;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      }
      if (this.data_fim) {
        this.filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));
      }

      if (this.filtroMonth) {
        this.range = "monthly";
      } else {
        this.range = "yearly";
      }

      axios
        .get("api/dashboard/gestor/analytics/report/vulnerabilidades", {
          params: {
            range: this.range,
            filtroYear: this.filtroYear, 
            filtroMonth: this.filtroMonth,
            filtroDatas: this.filtroDatas,
            anotherFilter: this.anotherFilter,
            pageCurrent: pageCurrent,
            perPage: perPage
          },
        })
        .then((response) => {
          this.loading = false;
          //this.report.por_vulnerabilidades = response.data.por_vulnerabilidades.data;
          //this.pagination = response.data.por_vulnerabilidades.pagination;
console.log(this.pagination)
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
     getAnalytics() {
      this.loading = true;
      this.showInputDatas = false;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(this.$options.filters.formatDateYMD(this.data_inicio));
      }
      if (this.data_fim) {
        this.filtroDatas.push(this.$options.filters.formatDateYMD(this.data_fim));
      }

      if (this.filtroMonth) {
        this.range = "monthly";
      } else {
        this.range = "yearly";
      }

      axios
        .get("api/dashboard/gestor/analytics/report", {
          params: {
            range: this.range,
            filtroYear: this.filtroYear, 
            filtroMonth: this.filtroMonth,
            filtroDatas: this.filtroDatas,
            anotherFilter: this.anotherFilter,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data;

          this.counts = response.data.counts;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    limparFiltros() {
      this.data_inicio = "";
      this.data_fim = "";
      this.verificaDataInicial = false;
      this.anotherFilter = [];
      this.valueYear = moment().format("YYYY");
      this.valueMonth = null;
      this.getAnalytics();
    },
    async generatePdf() {
      this.showPrint = true;

      const el = this.$refs.testHtml;
      const options = {
        type: "dataURL",
      };

      this.output = await this.$html2canvas(el, options);

      window.html2canvas = html2canvas;
      const doc = new jsPDF("p", "pt", "letter");

      const content = this.$refs.print;

      doc.html(content, {
        callback: function (doc) {
          doc.deletePage(2);
          doc.save("Gráficos-de-Atendimentos-Suas-Fácil.pdf");
        },
        x: 10,
        y: 10,
      });

      setTimeout(() => {
        this.showPrint = false;
      }, 1000);
    },
    exportCsv() {
      this.isLoadingMsg = true;
      this.loading = true;

      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/gestor/analytics/report", {
          params: {
            range: this.range,
            filtroYear: this.filtroYear,
            filtroMonth: this.filtroMonth,
            filtroDatas: this.filtroDatas,
            anotherFilter: this.anotherFilter,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
  },
};
</script>

<style scoped>
.donut-chart {
  height: 100% !important;
}

.print {
  height: 11in;
  width: 8.5in;
  margin: 15px;
}

.gestor-analytics .card-header {
  padding: 15px 0px !important;
}

#map {
  height: 100%;
}

.btn-card {
  position: absolute;
  right: -6px;
  top: 0px;
  border-radius: 0;
  border: 0;
}

.card-table {
  min-height: 414px;
  overflow-y: auto;
  max-height: 414px;
}

::-webkit-scrollbar-track {
  background-color: #f4f4f4;
}

::-webkit-scrollbar {
  width: 5px;
  background: #f4f4f4;
}

::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 25em;
}
</style>
